/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useState, useContext } from "react";
import { List, Input, Space, notification } from "antd";
import { SaveOutlined, PhoneOutlined, MailOutlined } from "@ant-design/icons";
import { observer } from "mobx-react-lite";
import ProfileStore from "../store/profilestore";
import "../components/userprofile.css";
import * as yup from "yup";
import { toJS } from "mobx";

export const SecuritySettingsView = observer(() => {
  const profileStore = useContext(ProfileStore);

  const [passwordObj, setPasswordObj] = useState({
    newpassword: "",
    confirmpassword: "",
  });
  const [phone, setPhone] = useState("");
  const [email, setEmail] = useState("");
  const savePassword = async () => {
    try {
      const { newpassword, confirmpassword } = passwordObj;
      const isequal = newpassword.localeCompare(confirmpassword);
      if (isequal !== 0) {
        notification.info({
          message: "SPARS Feedback",
          description:
            "password does not match,reveal by clicking the eye icon",
        });
        return;
      }
      profileStore.isSaving = true;
      const retVal = await profileStore.changePassword(newpassword);

      if (retVal.success) {
        notification.info({
          message: "SPARS Feedback",
          description: "password change successfull",
        });
        profileStore.editPassword = false;
      }
    } catch (error) {
      notification.error({
        message: "SPARS Feedback",
        description: error.message,
      });
    } finally {
      profileStore.isSaving = false;
    }
  };

  const savePhone = async () => {
    try {
      let values = toJS(profileStore.userprofile?.profile);
      values = { ...values, phoneNumber: phone };

      profileStore.isSaving = true;
      const retVal = await profileStore.updateUserProfile(values);
      if (retVal.success) {
        notification.success({
          message: "SPARS Feedback",
          description: "Account security phone  modifications successfull",
        });

        profileStore.userprofile.profile = { ...values };
        profileStore.editPhone = false;
      }
    } catch (error) {
      notification.error({
        message: "SPARS Feedback",
        description: error.message,
      });
    } finally {
      profileStore.isSaving = false;
    }
  };

  const saveEmail = async () => {
    try {
      let schema = yup.object().shape({
        email: yup.string().email(),
      });

      const isValid = await schema.isValid({
        email: email,
      });
      console.log(isValid);
      if (isValid) {
        let values = toJS(profileStore.userprofile?.profile);
        values = { ...values, email };

        profileStore.isSaving = true;
        const retVal = await profileStore.updateUserProfile(values);
        if (retVal.success) {
          notification.success({
            message: "SPARS Feedback",
            description: "Account security email modifications successfull",
          });

          profileStore.userprofile.profile = { ...values };
          profileStore.editEmail = false;
        }
      } else {
        notification.error({
          message: "SPARS Feedback",
          description: "invalid work email,please confirm the work email",
        });
      }
    } catch (error) {
      notification.error({
        message: "SPARS Feedback",
        description: error.message,
      });
    } finally {
      profileStore.isSaving = false;
    }
  };
  const getData = () => [
    {
      title: "Account Password",
      description: (
        <>
          {!profileStore.editPassword ? (
            <div>
              {" "}
              Current Password XXXXXXXXXXXX：
              <span>Okay</span>
            </div>
          ) : (
            <div className="ms-Grid" dir="ltr">
              <div className="ms-Grid-row">
                <div className="ms-Grid-col ms-sm4">
                  <Input.Password
                    placeholder="New assword here"
                    bordered={false}
                    onChange={({ target }) => {
                      setPasswordObj({
                        ...passwordObj,
                        newpassword: target.value,
                      });
                    }}
                    autoFocus
                  ></Input.Password>
                </div>
                <div className="ms-Grid-col ms-sm4">
                  <Input.Password
                    placeholder="Confirm new password here"
                    bordered={false}
                    onChange={({ target }) => {
                      setPasswordObj({
                        ...passwordObj,
                        confirmpassword: target.value,
                      });
                    }}
                  ></Input.Password>
                </div>
              </div>
            </div>
          )}
        </>
      ),
      actions: [
        <a
          key="Modify"
          style={{ display: !profileStore.editPassword ? "flex" : "none" }}
          onClick={() => {
            profileStore.editPassword = true;
          }}
        >
          <span>Modify</span>
        </a>,

        <Space style={{ display: profileStore.editPassword ? "flex" : "none" }}>
          <div style={{ color: "#40A9FF" }}>
            <SaveOutlined style={{ color: "#A0AEC0" }} />{" "}
            <a
              onClick={async () => {
                await savePassword();
              }}
            >
              Save Password
            </a>
          </div>
          |
          <div>
            <a
              onClick={() => {
                profileStore.editPassword = false;
              }}
            >
              Cancel
            </a>
          </div>
        </Space>,
      ],
    },

    {
      title: "Security Phone",
      description: (
        <>
          {!profileStore.editPhone ? (
            <span>
              Bound Phone：****
              {toJS(profileStore.userprofile?.profile?.phoneNumber)}
            </span>
          ) : (
            <Input.Group compact>
              <Input style={{ width: "10%" }} defaultValue="+234" readOnly />
              <Input
                style={{ width: "80%" }}
                autoFocus
                placeholder="Enter your mobile phone number"
                bordered={false}
                maxLength={11}
                onChange={({ target }) => {
                  setPhone(target.value);
                }}
              />
            </Input.Group>
          )}
        </>
      ),
      actions: [
        <a
          key="Modify"
          style={{ display: !profileStore.editPhone ? "flex" : "none" }}
          onClick={() => {
            profileStore.editPhone = true;
          }}
        >
          <span>Modify</span>
        </a>,

        <Space style={{ display: profileStore.editPhone ? "flex" : "none" }}>
          <div style={{ color: "#40A9FF" }}>
            <PhoneOutlined style={{ color: "#A0AEC0" }} />{" "}
            <a
              onClick={async () => {
                await savePhone();
              }}
            >
              Save
            </a>
          </div>
          |
          <div>
            <a
              onClick={() => {
                profileStore.editPhone = false;
              }}
            >
              Cancel
            </a>
          </div>
        </Space>,
      ],
    },

    {
      title: "Security Email",
      description: (
        <>
          {!profileStore.editEmail ? (
            <span>
              Bound Email：{toJS(profileStore.userprofile?.profile?.email)}
            </span>
          ) : (
            <Input
              autoFocus
              placeholder="Enter your work email"
              type="email"
              bordered={false}
              onChange={({ target }) => {
                setEmail(target.value);
              }}
            ></Input>
          )}
        </>
      ),
      actions: [
        <a
          key="Modify"
          style={{ display: !profileStore.editEmail ? "flex" : "none" }}
          onClick={() => {
            profileStore.editEmail = true;
          }}
        >
          <span>Modify</span>
        </a>,

        <Space style={{ display: profileStore.editEmail ? "flex" : "none" }}>
          <div style={{ color: "#40A9FF" }}>
            <MailOutlined style={{ color: "#A0AEC0" }} />{" "}
            <a
              onClick={async () => {
                await saveEmail();
              }}
            >
              Save
            </a>
          </div>
          |
          <div>
            <a
              onClick={() => {
                profileStore.editEmail = false;
              }}
            >
              Cancel
            </a>
          </div>
        </Space>,
      ],
    },
  ];
  return (
    <div
      className="ms-Grid"
      dir="ltr"
      style={{
        paddingTop: "8px",
        paddingRight: "40px",
        paddingBottom: "8px",
        paddingLeft: "40px",
      }}
    >
      <div className="ms-Grid-row">
        <div
          className="ms-Grid-col ms-sm12"
          style={{
            marginBottom: "12px",
            color: "rgba(0,0,0,.85)",
            fontWeight: "500",
            fontSize: "20px",
            lineHeight: "28px",
          }}
        >
          Security Settings
        </div>
      </div>
      <div className="ms-Grid-row">
        <div className="ms-Grid-col ms-sm12">
          <List
            itemLayout="horizontal"
            id="lstsecurity"
            dataSource={getData()}
            renderItem={(item) => (
              <List.Item actions={item.actions}>
                <List.Item.Meta
                  title={item.title}
                  description={item.description}
                />
              </List.Item>
            )}
          />
        </div>
      </div>
    </div>
  );
});

